<script setup lang="ts">
/**
 * PQ-002 — the visual acknowledgement that a backend call is in progress.
 * The animation is decorative; the accessible name is what a screen reader announces.
 */
withDefaults(defineProps<{ size?: 'sm' | 'md' | 'lg'; label?: string }>(), {
  size: 'md',
  label: 'Cargando',
});

const SIZES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
} as const;
</script>

<template>
  <span
    class="inline-flex items-center gap-2"
    role="status"
  >
    <span
      :class="[
        SIZES[size],
        'inline-block animate-spin rounded-full border-brand-600 border-t-transparent',
      ]"
      aria-hidden="true"
    />
    <span class="sr-only">{{ label }}</span>
  </span>
</template>
